const ITEMS = ["GUITAR", "KEYBOARD", "VIOLIN", "FLUTE", "SINGING", "COMPOSITION", "SION EAST · MUMBAI", "PLAY FIRST, PAY LATER"];

export default function Marquee({ dark = false }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className={`overflow-hidden border-y ${dark ? "bg-ink text-paper border-paper/10" : "bg-gold/10 border-ink/10"}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex whitespace-nowrap py-3.5 w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-body font-extrabold text-sm sm:text-base tracking-[0.15em] px-6">
            {item}
            <span className={`ml-12 inline-block w-8 border-t-2 border-dashed ${dark ? "border-gold" : "border-brand"}`} />
          </span>
        ))}
      </div>
    </div>
  );
}
